// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"cc4d6fef","121":"cc4d6fef","340":"78d477de","341":"356bab37","369":"d341cb39","970":"48983339"}[chunkId] + ".chunk.css";
};